import { Component, Inject, OnInit, OnDestroy, ElementRef, Input, Output, EventEmitter, ChangeDetectorRef, ViewChild } from '@angular/core';
import { NbAutocompleteDirective, NbSidebarService } from "@nebular/theme";
import { DOCUMENT } from '@angular/common';
import { environment } from "src/environments/environment";
import { BaseApiService } from "../api.service";
import { map, Observable, Subject, takeUntil } from 'rxjs';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/auth/auth.service';
import { NotifyService } from 'src/app/common/services/notify.service';
import { SidebarService } from 'src/app/common/services/sidebar.service';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { ProfileService } from '../../common/services/profile.service';
import { IUserProfile } from 'src/app/common/interfaces/IProfile';
import { EnvironmentService } from 'src/app/core/services/environment.service';
import { TransmitService } from 'src/app/core/services/transmit.service';
import { addCurrency, serviceTypes, urlJoin } from 'src/app/core/common/public';
import { ServiceType } from 'src/app/core/common/types';
import { ApiService } from 'src/app/modules/public/api.service';
import { ISearchResult } from 'src/app/modules/public/p-interface';
import { generateUrlByServiceType } from 'src/app/modules/public/public-methods';
import { setUserName } from 'src/app/core/common/public';
import { PermissionConditionObj, UserPermissions } from 'src/app/common/menu/types';
import { AuthService as PermissionService } from 'src/app/common/services/auth.service'
import { HttpService } from 'src/app/core/services/http.service';

declare var Goftino

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    providers: [BaseApiService, ApiService],
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() showSidebar: boolean;
  currentTheme = 'default';
  private _notificationsTimer: any = 0;
  isMobileSize: boolean;
  showNotifications: boolean = false;
  showMenu: boolean = false;
  serverMode = environment.serverMode
  userType: string;
  userData: IUserProfile = {
    avatar: '',
    first_name: '',
    is_complete: true,
    last_name: '',
    national_code: '',
    phone: '',
    pk: 0,
    user_type: '',
    extra_data: {
      name: '',
      national_id: '',
      registration_number: ''
    },
    email: '',
    is_active: false,
    last_activity: 0
  };
  isActive: boolean = false;
  logOutbutton: boolean = false;
  fixBadge: boolean = false;
  notifier = new Subject<void>();
  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
  ];
  unridedNotification: number;
  userPictureOnly: boolean = false;
  user: any;
  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];
  dropDown: boolean = false;
  servicesMenu: boolean = false;
  complaintDropDown: boolean = false;
  petitionDropDown: boolean = false;
  isSearch: boolean = false;
  isSearchResponsive : boolean = false
  isNotification: boolean = false;
  result: ISearchResult[] = [];
  resultType: string;
  searchText: string;
  searchPage: number = 0;
  popularItems = [
    {
      title: 'قرارداد آماده',
      link : urlJoin(environment.djangoUrl, 'contract/ready/')
    },
    {
      title: 'دادخواست آماده',
      link : urlJoin(environment.djangoUrl, 'petition/ready/')
    },
    {
      title: 'دادخواست هوشمند',
      link : urlJoin(environment.djangoUrl, 'petition/smart/')
    },
    {
      title: 'سفارش شکوائیه',
      link : urlJoin(environment.djangoUrl, 'complaint/custom/')
    },
    {
      title: 'سفارش قرارداد',
      link : urlJoin(environment.djangoUrl, 'contract/custom/')
    }
  ]
  @ViewChild(NbAutocompleteDirective) autocompleteDirective: NbAutocompleteDirective<string>;
  private _subscription: any;
  permissions: any;
  constructor(
    private _router: Router,
    @Inject(DOCUMENT) private document: any,
    private _apiService: BaseApiService,
    private _publicApiService: ApiService,
    private _sidebarService: SidebarService,
    private breakpointObserver: BreakpointObserver,
    private _profileService: ProfileService,
    public env: EnvironmentService,
    private transmit: TransmitService,
    public authService: AuthService,
    private cdr: ChangeDetectorRef,
    private _permissionService: PermissionService,
    private http: HttpService,
  ) { }

  ngOnInit(): void {
    // this.env.loadNotifications();
    this.setIsMobileSize()
    // this._notificationsTimer = setInterval(() => {
    // }, 5000);
    // this.setIsMobileSize()
    // this.getUserData();
    this.transmit.listen('profile-data').pipe(takeUntil(this.notifier)).subscribe(it => {
      if (!it) return;
      this.userData = this.env.profileInfo;
      this.goftinoEvent()
    })
    this._setPermission()
  }

  ngOnDestroy(): void {
    clearTimeout(this._notificationsTimer);
    this.notifier.next();
    this.notifier.complete();
  }

  private _setPermission() {
    this._subscription = this._permissionService.onPermissionsUpdated$.pipe(takeUntil(this.notifier)).subscribe(
      (userPermissions: UserPermissions) => {
        const permissions: PermissionConditionObj = {
          isLawyer: { permissions: ['lawyer'], notBeAdmin: true },
        };
        this.permissions = this._permissionService.createPermissionObj(
          permissions,
          userPermissions
        );
      }
    );
  }
  private setIsMobileSize(): void {
    this.breakpointObserver.observe([
      "(max-width: 1140px)"
    ]).subscribe((result: BreakpointState) => {
      this.isMobileSize = result.matches;
    });
  }


  toggleSidebarVisibility() {
    this._sidebarService.toggleVisibility();
  }

  toggleMenuVisibility() {
    this._sidebarService.toggleMenuVisibility();
  }


  cutString(str) {
    if (str) {
      if (str.length > 120) {
        return str.substring(0, 120) + '...';
      }
      else {
        return str;
      }
    } else {
      return str;
    }
  }


  changeTheme(event: any) { }

  goToHomePage() {
    return this.env.goToHomePage()
  }

  toggleNotificationList() {
    this.showNotifications = !this.showNotifications;
  }

  // getUserData() {
  //   if (localStorage.getItem('access_token')) {
  //     this._profileService.profile.subscribe({
  //       next: (profile) => {
  //         this.userData = profile;
  //       },
  //       error: (err) => {
  //         this._router.navigateByUrl('/auth/logout');
  //       }
  //     })
  //   }
  // }


  showLogOut() {
    this.logOutbutton = !this.logOutbutton;
  }

  dropDownMenu() {
    this.dropDown = !this.dropDown;
  }

  clickedOutside(mode?: string) {
    if (mode === 'notification') { this.showNotifications = false; }
    else if (mode === 'logout') { this.logOutbutton = false; }
    else if (mode === 'dropDown-menu') { this.dropDown = false; }
    else if (mode === 'services-menu') { this.servicesMenu = false; }
    else if (mode === 'complaint-dropdown') { this.complaintDropDown = false; }
    else if (mode === 'petition-dropDown') {this.petitionDropDown = false;}
    else if (mode === 'search') {this.isSearch = false}
    else if (mode === 'notification-container') {this.isNotification = false;}
    else {
      this.showNotifications = false;
      this.logOutbutton = false;
    }
  }
  goToWallet() {
    this._router.navigateByUrl('/payment/payment-list')
  }

  gotoPage(link: string) {
    window.location.href = urlJoin(environment.djangoUrl, link);
  }

  goToSearchPage(slug: string, type: ServiceType) {
    window.location.href = urlJoin(environment.djangoUrl,generateUrlByServiceType(type,slug));  
  }
  gotoPagePanel(link: string) {
    this._router.navigateByUrl(link);
  }
  gotoMessagePage(link : string , uuid  :string){
    this._router.navigateByUrl(`${link}/${uuid}`)
  }
  goToChat() {
    let userRole;
    this.permissions.isLawyer ? userRole = 'lawyer' : userRole = 'user';
    this._router.navigateByUrl(`chat/chat-list/${userRole}`)
  }
  toggleServicesMenu() {
    this.servicesMenu = true;
  }

  //TODO: to be removed
  goToContactUs(){
    window.location.href = urlJoin(environment.djangoUrl, 'contact-us')
  }

  openSearch() {
    window.innerWidth > 700 ?  this.isSearch = !this.isSearch : this.isSearchResponsive = !this.isSearchResponsive;
  }

  openNotification(){
    this.isNotification = !this.isNotification;
  }

  complaintDropDownMenu(){
    this.complaintDropDown = true;
  }

  petitionDropDownMenu() {
    this.petitionDropDown = true;
  }

  async loadsearch(reset?: boolean) {
    if(this.searchText.length === 0) {
      this.result = [];
      this.searchPage = 0 
    }
    else {
      let res = await this._publicApiService.mainSearchBar(this.searchText);
      if (res.statusCode === 200) {
        this.result = [];
        this.searchPage = 0
        this.searchPage = res.paginate.total_pages
        this.result = res.data['products'];
        this.result.map((item) => {
          item.translatedType = serviceTypes(item.type)
        })
        this.autocompleteDirective.show();
        this.cdr.detectChanges();
      }
    } 
    // else if (this.searchText.length === 0) {
    //   this.result = [];
    //   this.searchPage = 0
    //   console.log(this.result.length)
    // }
  }

  goToPage(uuid: string, type: ServiceType) {
    this._router.navigateByUrl(generateUrlByServiceType(type, uuid))
  }

  showMoreResult(text:string){
    console.log(text)
    window.location.href = urlJoin(environment.djangoUrl, 'products?q=' + text);
  }

  setUserNameFunc(){
    return setUserName(this.userData)
  }

  goftinoEvent() {
  this.transmit
    .listen('goftino_ready')
    .pipe(takeUntil(this.notifier))
    .subscribe(async (isGoftinoReady) => {
      if (isGoftinoReady) {
        Goftino.setUser({
          name: setUserName(this.userData),
          phone: this.userData.phone,
          avatar: this.userData.avatar,
          forceUpdate: true,
        });
        let goftinoId;
        if (!this.userData.goftino_id) {
          goftinoId = await Goftino.getUserId(); 
          if (!goftinoId) return
          let res = await this.http.getSuccessResult({
            method: 'POST',
            path: 'accounts/profile/',
            body: {
              goftino_id: Goftino.getUserId(),
            },
          });
        } else {
          goftinoId = this.userData.goftino_id;
        }
          Goftino.setUserId(goftinoId, function (callback) {
            if (callback.status === 'success') {
              console.log('goftino id has been saved sucessfully!');
            }
          });
      }
    });
  }
}


